<div class='delivery-follow-ups-tab-2-part'>
	This is tab 2
</div>